// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7ef3a29f","732":"acd4d286","977":"80003558"}[chunkId] + ".chunk.js";
};